
import React from 'react';
import { motion } from 'framer-motion';

function StatCard({ number, label, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="text-left"
    >
      <div className="font-rocky-light text-4xl md:text-5xl font-light italic text-primary mb-2" style={{ fontVariantNumeric: 'tabular-nums' }}>
        {number}
      </div>
      <div className="whitespace-pre-line text-sm leading-relaxed text-foreground/80 md:text-base">
        {label}
      </div>
    </motion.div>
  );
}

export default StatCard;
